(() => {
  const body = document.body;

  const trapFocus = (container, event) => {
    const focusable = [...container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter((element) => element.offsetParent !== null);
    if (!focusable.length || event.key !== 'Tab') return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  document.querySelectorAll('[data-mobile-drawer]').forEach((drawer) => {
    const openers = document.querySelectorAll('[data-menu-open]');
    const closer = drawer.querySelector('[data-menu-close]');
    let lastTrigger;

    const open = (trigger) => {
      lastTrigger = trigger;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger?.setAttribute('aria-expanded', 'true');
      body.classList.add('is-locked');
      closer?.focus();
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lastTrigger?.setAttribute('aria-expanded', 'false');
      body.classList.remove('is-locked');
      lastTrigger?.focus();
    };

    openers.forEach((trigger) => trigger.addEventListener('click', () => open(trigger)));
    closer?.addEventListener('click', close);
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      trapFocus(drawer, event);
    });
  });

  document.querySelectorAll('[data-search-dialog]').forEach((dialog) => {
    const openers = document.querySelectorAll('[data-search-open]');
    const closer = dialog.querySelector('[data-search-close]');
    let lastTrigger;

    const open = (trigger) => {
      lastTrigger = trigger;
      document.querySelectorAll('[data-mobile-drawer].is-open').forEach((drawer) => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('[data-menu-open]').forEach((menuTrigger) => menuTrigger.setAttribute('aria-expanded', 'false'));
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      body.classList.add('is-locked');
      window.setTimeout(() => dialog.querySelector('input[type="search"]')?.focus(), 50);
    };

    const close = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      body.classList.remove('is-locked');
      lastTrigger?.focus();
    };

    openers.forEach((trigger) => trigger.addEventListener('click', () => open(trigger)));
    closer?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', () => body.classList.remove('is-locked'));
  });

  const revealItems = document.querySelectorAll('.reveal-item');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantSelect = root.querySelector('[data-variant-select]');
    const idInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-button]');
    const buttonText = root.querySelector('[data-add-button-text]');
    const price = root.querySelector('[data-product-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const variantsElement = root.querySelector('[data-product-variants]');
    if (!variantSelect || !variantsElement) return;

    let variants = [];
    try { variants = JSON.parse(variantsElement.textContent); } catch (_) { return; }

    variantSelect.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === variantSelect.value);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = variant.price_formatted;
      if (comparePrice) {
        comparePrice.textContent = variant.compare_at_price_formatted || '';
        comparePrice.hidden = !variant.compare_at_price_formatted;
      }
      if (addButton) addButton.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? buttonText.dataset.available : buttonText.dataset.soldOut;
      if (history.replaceState) history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
})();
